import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ContactForm from './Pages/Home/Contact/ContactForm'
import Home from "./Pages/Home/Home/Home";
import ProjectDetails from './Pages/ProjectDetails/ProjectDetails';
import Blog from "./Pages/Blog/Blog";
import About from "./Pages/Home/About/About";
import NavBar from "./Pages/NavBar/NavBar";
import Projects from "./Pages/Projects/Projects";

function App() {
  return (
    <div className="App overflow-hidden bg-dark text-white" style={{ minHeight: "100vh" }}>
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactForm />}></Route>
          <Route path="/home" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="project/:id" element={<ProjectDetails />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;
